import { defineComponent, h, useAttrs } from 'vue'
import { VListItem } from 'vuetify/components'
import { hasBooleanishAttr } from './legacyInputProps'

function normalizeAttrs(attrs) {
  const normalized = { ...attrs }

  if (hasBooleanishAttr(attrs.dense) && normalized.density == null) {
    normalized.density = 'compact'
  }

  delete normalized.dense

  return normalized
}

function resolveLegacyActive(attrs = {}, scope = {}) {
  return Boolean(
    attrs.inputValue ??
    attrs['input-value'] ??
    scope.active ??
    scope.isActive ??
    scope.isSelected ??
    scope.selected ??
    false
  )
}

export default defineComponent({
  name: 'VListItemCompat',
  compatConfig: {
    RENDER_FUNCTION: false,
    COMPONENT_V_MODEL: false,
    INSTANCE_ATTRS_CLASS_STYLE: false
  },
  inheritAttrs: false,

  setup(_, { slots }) {
    const attrs = useAttrs()

    return () =>
      h(VListItem, normalizeAttrs(attrs), {
        ...slots,
        default: slots.default
          ? (scope = {}) =>
              slots.default({
                ...scope,
                active: resolveLegacyActive(attrs, scope)
              })
          : undefined
      })
  }
})
